import { ReactNode, useEffect } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useAtom } from 'jotai';
import { GOOGLE_CLIENT_ID } from '../../../config/env';
import { triggerRefresh } from '../api/clients';
import authAtom from '../authAtom';
import useProactiveRefresh from '../hooks/useProactiveRefresh';

interface Props {
  children: ReactNode;
}

const AuthProvider = ({ children }: Props) => {
  const [session, setSession] = useAtom(authAtom);
  useProactiveRefresh(session, triggerRefresh);

  useEffect(() => {
    if (session === undefined) {
      setSession(null);
    }
  }, [session, setSession]);

  return <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{children}</GoogleOAuthProvider>;
};

export default AuthProvider;
